import { Component, inject, OnDestroy } from '@angular/core';
import { debounceTime, takeUntil } from 'rxjs/operators';
import { OfferStepsEnum } from '@app/enums/offer-steps.enum';
import { ActivatedRoute, Router } from '@angular/router';
import { SnackbarService } from '@app/services/snackbar.service';
import { DeviceService } from '@app/services/device.service';
import { Subject } from 'rxjs';
import {
    MatAccordion,
    MatExpansionPanel,
    MatExpansionPanelHeader,
    MatExpansionPanelTitle,
} from '@angular/material/expansion';
import { MatButton } from '@angular/material/button';
import { FlexModule } from '@angular/flex-layout';
import { MatProgressSpinner } from '@angular/material/progress-spinner';
import { MortgagesService } from '@app/services/mortgages.service';
import { MortgageInterface } from '@app/interfaces/mortgage.interface';

@Component({
    selector: 'app-actual-step-redirect',
    styleUrls: ['./actual-step-redirect.component.scss'],
    templateUrl: './actual-step-redirect.component.html',
    imports: [
        MatAccordion,
        MatExpansionPanel,
        MatExpansionPanelTitle,
        MatExpansionPanelHeader,
        MatProgressSpinner,
        MatButton,
        FlexModule,
    ],
})
export class ActualStepRedirectComponent implements OnDestroy {
    protected readonly route = inject(ActivatedRoute);
    protected readonly router = inject(Router);
    protected readonly snackbarService = inject(SnackbarService);
    protected readonly deviceService = inject(DeviceService);
    protected readonly mortgagesService = inject(MortgagesService);

    protected destroyed$: Subject<void> = new Subject<void>();

    missingMortgageRedirect: any;

    constructor() {
        this.setMortgageFromRouteData();
        this.mortgagesService.mortgage$
            .pipe(debounceTime(300), takeUntil(this.destroyed$))
            .subscribe((mortgage: MortgageInterface) => {
                clearTimeout(this.missingMortgageRedirect);
                if (mortgage) {
                    this.mortgagesService.navigateToActualStep();
                } else {
                    this.missingMortgageRedirect = setTimeout(() => {
                        this.snackbarService.showError(
                            'Je nám líto, nabídka nebyla nalezena. Zkuste prosím oranžové tlačíko "Pokračovat". V ostatních případech jsme Vám plně k dispozici na telefonu či e-mailu. Děkujeme'
                        );
                        this.router
                            .navigate([this.deviceService.isDesktop ? '/dashboard' : '/mobile/dashboard'])
                            .then();
                    }, 5000);
                }
            });
    }

    ngOnDestroy(): void {
        this.destroyed$?.next();
        this.destroyed$?.complete();
    }

    protected setMortgageFromRouteData() {
        const mortgage: MortgageInterface = this.route.snapshot.data?.mortgage;
        if (mortgage && !this.mortgagesService.mortgage) {
            if (!mortgage.fillingScore) {
                mortgage.fillingScore = OfferStepsEnum.Calculator;
            }
            this.mortgagesService.setMortgage(mortgage);
        }
        return mortgage;
    }
}
